module.exports = __webpack_public_path__ + "img/AC charging 2.b2b56466.svg";